import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Base from './Componentes/Base';
import SubirFotoQR from './Componentes/SubirFotoQR';
import { tokenDesdeRuta } from './lib/fotosQR';
import reportWebVitals from './reportWebVitals';

// /subir/<token> es la única ruta pública: la abre el teléfono al escanear el
// QR del generador de hiloramas y no pasa por el login de Base.
const tokenSubida = tokenDesdeRuta();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {tokenSubida ? <SubirFotoQR token={tokenSubida} /> : <Base />}
  </React.StrictMode>
);

// If you want to start measuring performance in your code, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
